import { useState } from "react";
import { DragIcon, DraggingIcon } from "../../asset/image";

export const DragHandle = (props) => {
  const [hovering, setHovering] = useState(false);

  const handleMouseEnter = () => {
    setHovering(true);
  };

  const handleMouseLeave = () => {
    setHovering(false);
  };

  return (
    <div
      {...props}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      css={{
        width: "24px",
        height: "15px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "move",
      }}
    >
      <img width="8" src={hovering ? DraggingIcon : DragIcon} />
    </div>
  );
};
